import MenuBookIcon from "@mui/icons-material/MenuBook";
import { resources as EmployeePublications } from "./EmployeePublications";
import { resources as GenerateFileForNacid } from "./GenerateFileForNacid";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <MenuBookIcon />,
  name: "Научна дейност",
  title: "Научна дейност",
  subMenu: [EmployeePublications],
};
